export default __webpack_public_path__ + "static/media/bar.04eea323.png";